const HEADER = {
  home: 'Início',
  bellSoundEnabled: 'O som da campainha está habilitado',
  bellSoundDisabledStoreClosed:
    'O som da campainha está desabilitado porque a loja está fechada',
  bellClickToEnable: 'Clique na tela para habilitar o som da campainha',
  closeStoreReminder: 'Não se esqueça de fechar a loja antes de ir embora',
}

export default HEADER
